export default "__VITE_ASSET__Dx$XDwYZ__"